
import Container from '../../../container';
import Content from '../../../content';

/**
   * @component BrowserComponent
   */

export default {
  name: 'BrowserComponent',
  components: {
    Container,
    Content,
  },
};
